export default __webpack_public_path__ + "0e4e5b742ea25cc40b7924e26fc21b99.png";